export const passwordRegex = /^(?=.*[A-Z])(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;
export const phoneRegex = /^(?:\(?\d{2}\)?\s?)?(?:9\d{4}|\d{4})\-?\d{4}$/;
export const cepRegex = /^\d{5}-?\d{3}$/;
